import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import styled from 'styled-components';

import H3 from './styledComponents/H3';
import RuleDescription from './styledComponents/RuleDescription';
import Base from './styledComponents/Base';
import BadGeneral from './styledComponents/BadGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor,DevicesList } from './blockComponents'
import { PlainImage } from './imageComponents';

const RuleImages = styled(Grid)`
    margin-top: 64px;
`;

function Devices({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
    return (
        <ParentAnchor
            key='devicesSection'
            blockId="devices-section"
            blockName='devicesSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_4' })} downloadLink="https://drive.google.com/drive/folders/1zzj6uCTS0EZ2_SAlozeTO_d64DGFzATt?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <AnchorBlock
                            key='devicesUsage'
                            blockName='devicesUsage'
                            blockId='devices-usage'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'devices_2_1' })}</H3>
                            <RuleDescription rule="do">{intl.formatMessage({ id: 'devices_1_1' })}</RuleDescription>
                            <PlainImage src="devices/products_1@2x.jpg" alt="" />
                            <PlainImage src="devices/products_2@2x.jpg" alt="" />
                            <Grid>
                                <Cell col={6}>
                                    <PlainImage src="devices/products_3@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={6}>
                                    <PlainImage src="devices/products_4@2x.jpg" alt="" />
                                </Cell>
                            </Grid>
                            <PlainImage src="devices/products_5@2x.jpg" alt="" />
                            <PlainImage src="devices/products_6@2x.jpg" last="xs" alt="" />
                            <RuleImages>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription>{intl.formatMessage({ id: 'devices_2_2' })}</RuleDescription>
                                    <PlainImage src="devices/products_do-donts_5@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription>{intl.formatMessage({ id: 'devices_2_3' })}</RuleDescription>
                                    <PlainImage src="devices/products_do-donts_7@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription>{intl.formatMessage({ id: 'devices_2_4' })}</RuleDescription>
                                    <PlainImage src="devices/products_do-donts_6@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription>{intl.formatMessage({ id: 'devices_2_5' })}</RuleDescription>
                                    <PlainImage src="devices/products_do-donts_8@2x.jpg" alt="" />
                                </Cell>
                            </RuleImages>
                            <Base space="TopDown">{intl.formatMessage({ id: 'devices_2_6' })}</Base>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="devices/products_do-donts_3@2x.jpg" last="sm" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="devices/products_do-donts_4@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                            <Base space="TopDown">{intl.formatMessage({ id: 'devices_2_7' })}</Base>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="devices/products_do-donts_1@2x.jpg" last="sm" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="devices/products_do-donts_2@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>
                        <AnchorBlock
                            key='devicesProportion'
                            blockName='devicesProportion'
                            blockId='devices-proportion'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'devices_3_1' })}</H3>
                            <DevicesList />
                        </AnchorBlock>
                        <AnchorBlock
                            key='devicesNaming'
                            blockName='devicesNaming'
                            blockId='devices-naming'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'devices_4_1' })}</H3>
                            <BadGeneral space="Down">{intl.formatMessage({ id: 'devices_4_2' })}</BadGeneral>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="devices/products_typing_1@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="devices/products_typing_3@2x.jpg" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="devices/products_typing_2@2x.jpg" last="sm" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="devices/products_typing_4@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
    )
}

export default injectIntl(Devices)